import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { ButtonType, ButtonWidget, InteractionState, TabStyles } from '@tableau/widgets';
import { ExplorerDropdownStyles } from './ExplorerDropdownStyles';

export interface ExplorerDropdownIconButtonProps {
  readonly onClick: (e: React.SyntheticEvent<HTMLDivElement, Event>) => void;
  readonly testId: string;
  readonly renderButtonContent: (showingOrActive: boolean, disabled: boolean) => JSX.Element | string;
  readonly title?: string;
  readonly showingPanel?: boolean;
  readonly height?: string;
  readonly setButtonRef?: (ref: HTMLButtonElement | null) => void;
  readonly buttonStyleOverrides?: React.CSSProperties;
  readonly disabled?: boolean;
}

export function ExplorerDropdownIconButton(props: ExplorerDropdownIconButtonProps): JSX.Element {

  return (
    <ButtonWidget buttonType={ButtonType.IconOutline}
      handleClick={props.onClick}
      testId={props.testId}
      title={props.title}
      style={{ ...ExplorerDropdownStyles.ExplorerDropdownButtonGenericStyle, ...props.buttonStyleOverrides }}
      ref={React.useCallback(ref => props.setButtonRef(ref ? ReactDOM.findDOMNode(ref) as HTMLButtonElement : null), [props.setButtonRef])}
      disabled={props.disabled}
      getContent={(interactionState: InteractionState) => {
        const showingOrActive = props.showingPanel || interactionState.hover || interactionState.active || interactionState.focus;
        return (
          <div
            style={{ height: props.height || 'auto' }}
            className={ExplorerDropdownStyles.IconOnlyActionMenu}
          >
            {props.renderButtonContent(showingOrActive, props.disabled)}
          </div>
        );
      }}
    />
  );
}
